var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200 -550)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8886",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(200 550)",
    style: {
      fill: "#e8cfff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9299"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 898",
    d: "M754.3 417.349c-2.9-.017-5.3-6.093-5.3-9.188 0-5.055 3.7-6.161 5.124-6.161a5.777 5.777 0 0 1 1.933.488 4.239 4.239 0 0 0 1.1.325 3.374 3.374 0 0 0 .792-.263 6.222 6.222 0 0 1 2.387-.592h.005a4.846 4.846 0 0 1 4.094 2.12l.3.46-.43.333a3.72 3.72 0 0 0-1.734 3.057 3.455 3.455 0 0 0 1.878 3.19c.269.166.547.337.547.711 0 .244-1.9 5.491-4.664 5.491a3.679 3.679 0 0 1-1.575-.392 3.13 3.13 0 0 0-1.4-.346 3.536 3.536 0 0 0-1.11.308 5.328 5.328 0 0 1-1.925.461zm0 0",
    transform: "translate(-537 162.651)",
    style: {
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 899",
    d: "M961.8 284c.072 2.659-1.783 4.5-3.636 4.388A4.206 4.206 0 0 1 961.8 284zm0 0",
    transform: "translate(-738.164 276)",
    style: {
      fill: "#7833ba"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginApple);
export default __webpack_public_path__ + "static/media/login_apple.0a381ceb446b14e4e3cccf761fdc56f4.svg";
export { ForwardRef as ReactComponent };